/**
 * Settings Page
 *
 * Displays current user details, assigned roles, and permissions
 */

import PageHeader from '@/components/common/PageHeader';
import { Col, Row } from 'antd';
import {
  CurrentUserCard,
  PermissionSummaryCard
} from '../components';
import { useGetCurrentUser } from '@/hooks/app';
import { PermissionChecker } from '@/utils/permission';

export const Settings = () => {
  // Get current user permissions
  const { data: currentUserData } = useGetCurrentUser();
  const permissions = currentUserData?.permission;

  // Initialize PermissionChecker
  const permissionChecker = new PermissionChecker(permissions);

  // Permission checks
  const canViewSettings = permissionChecker.canViewSettings();

  return (
    <div className="p-4">
      <PageHeader
        title="Settings"
        subtitle="View your account details, assigned roles, and permissions"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Settings' },
        ]}
      />

      {canViewSettings && (
        <Row gutter={[24, 24]} className="mt-6">
          {/* Current User Info */}
          <Col span={24}>
            <CurrentUserCard />
          </Col>

          {/* Permission Summary */}
          <Col span={24}>
            <PermissionSummaryCard />
          </Col>

        {/* User Impersonation */}
        {/* <Col span={24}>
          <UserImpersonationCard
            companyAdmins={companyAdmins}
            analyticsUsers={analyticsUsers}
            customerUsers={customerUsers}
            onImpersonate={quickImpersonate}
          />
        </Col> */}

        {/* Quick Access Users */}
        {/* <Col xs={24} md={8}>
          <QuickAccessCard
            title="Company Admins"
            icon={<MdAdminPanelSettings />}
            iconColor="text-red-500"
            description="Full access to all regions and features"
            users={companyAdmins}
            onUserClick={quickImpersonate}
          />
        </Col>

        <Col xs={24} md={8}>
          <QuickAccessCard
            title="Analytics Users"
            icon={<MdAnalytics />}
            iconColor="text-blue-500"
            description="Regional access with data export"
            users={analyticsUsers}
            onUserClick={quickImpersonate}
            showRegions
          />
        </Col>

        <Col xs={24} md={8}>
          <QuickAccessCard
            title="Customer Users"
            icon={<MdBusiness />}
            iconColor="text-green-500"
            description="View own data only"
            users={customerUsers}
            onUserClick={quickImpersonate}
            showRegions
          />
        </Col> */}

        {/* Testing Guide */}
        {/* <Col span={24}>
          <TestingGuideCard onQuickImpersonate={quickImpersonate} />
        </Col> */}
        </Row>
      )}
    </div>
  );
};

export default Settings;
